import { createJSONStorage, persist } from 'zustand/middleware';
import { create } from 'zustand/react';
import { InterviewType } from '../model';

type NylasCalendarStore = {
  dontShowAgain: boolean;
  setDontShowAgain: (dontShowAgain: boolean) => void;
  interviewType: InterviewType;
  setInterviewType: (interviewType: InterviewType) => void;
};

export const useNylasCalendarStore = create<NylasCalendarStore>()(
  persist(
    (set) => ({
      dontShowAgain: false,
      setDontShowAgain: (dontShowAgain: boolean) => set({ dontShowAgain }),

      interviewType: InterviewType.Online,
      setInterviewType: (interviewType: InterviewType) => set({ interviewType }),
    }),
    {
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ dontShowAgain: state.dontShowAgain, interviewType: state.interviewType }),
      name: 'nylas-calendar',
    },
  ),
);

export const useNylasCalendarInterviewType = () => {
  return useNylasCalendarStore((state) => state.interviewType);
};

export const useNylasCalendarSetInterviewType = () => {
  return useNylasCalendarStore((state) => state.setInterviewType);
};

export const getNylasInterviewType = () => {
  return useNylasCalendarStore.getState().interviewType;
};

export const useNylasCalendarDontShowAgain = () => {
  return useNylasCalendarStore((state) => state.dontShowAgain);
};

export const useNylasCalendarSetDontShowAgain = () => {
  return useNylasCalendarStore((state) => state.setDontShowAgain);
};

export const getDontShowAgain = () => {
  return useNylasCalendarStore.getState().dontShowAgain;
};
